<template>
  <v-dialog
    :value="value"
    width="600"
    @click:outside="$emit('input', false)">
    <v-card
      class="main--text">
      <v-container
        fluid>
        <v-row>
          <v-col>
            パスワード再設定メールをお送りします。<br>
            以下のフォームにご登録のメールアドレスを入力のうえ、<br>
            送信ボタンを押下ください。
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field
            v-model="email"
            prepend-icon="person"
            label="メールアドレス"
            type="text"
            v-validate="'required|email'"
            data-vv-name="email"
            data-vv-as="メールアドレス"
            required
            :error-messages="errors.collect('email')"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row
          justify="end">
          <v-col
            cols="auto">
            <v-btn
              depressed
              outlined
              rounded
              @click="$emit('input', false)"
              >閉じる</v-btn>
          </v-col>
          <v-col
            cols="auto">
            <v-btn
              depressed
              outlined
              rounded
              color="primary"
              @click="submit">送信</v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
    },
    error: {
      type: String
    }
  },
  data () {
    return {
      email: ""
    }
  },
  methods: {
    submit () {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$emit("submit-button-click", this.email)
        }
      })
    }
  }
}
</script>
